/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : production.ts
*******************************************/

import { BarrierDisplayMode } from "@api-commons/sdk/aaa/AAABarrierWithSource.js";
import { commonConfig } from "./common.js";

export const config = commonConfig;

config.host = "api.cookist.com";
config.domain = "cookist.com";
config.mainUrl = "https://www.cookist.com";
config.secure = true;
config.debug = true;
config.webPush.serviceWorkerHost = "cookist.com";
config.snhubConfig.domain = "cookist.com";
config.cookies.cookieDomain = ".cookist.com";

config.snhubConfig.secure = true;
config.snhubConfig.host = "api.cookist.com";
config.snhubConfig.enabled = true;

config.ga4.cookieDomain = ".cookist.com";

config.assetsDistro = "https://d1tu8rgtdmw448.cloudfront.net";

config.loginManager.barrierDisplayMode = BarrierDisplayMode.SHOW_DIALOG;
config.loginManager.actual_providers.email.enabled = true;
config.loginManager.actual_providers.email.codeLoginAllowed = true;

config.nativeApp.dynamicLink.baseUrl = "https://cookist.page.link/app";